import { render, staticRenderFns } from "./Ques.vue?vue&type=template&id=165cfe04&scoped=true&"
import script from "./Ques.vue?vue&type=script&lang=js&"
export * from "./Ques.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "165cfe04",
  null
  
)

export default component.exports